import {
  Box,
  Button,
  Typography,
  useTheme,
  Modal,
  TextField,
  MenuItem,
} from "@mui/material";
import ListComponent from "../Templates/ListComponent";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const ProtectedDownloads = (props) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [devices, setDevices] = useState([
    {
      deviceName: "Jetcore",
      deviceId: "JET0041",
      status: "Inactive",
      lastUpdated: "11/05/2025",
    },
  ]);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    deviceId: "",
    deviceName: "",
    status: "Active",
    lastUpdated: "",
  });

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: theme.palette.primary.main,
    boxShadow: theme.shadows[5],
    color: theme.palette.text.primary,
    borderRadius: 1,
    p: 4,
  };

  const handleNewDeviceClick = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFormData({
      deviceId: "",
      deviceName: "",
      status: "Active",
      lastUpdated: "",
    }); // Reset form
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDevices([...devices, formData]); // Add new device to the array
    handleClose();
  };

  const handleDeviceClick = (deviceId) => {
    navigate("/remoteSSH", { state: { deviceId } });
  };

  const availableDevices = ["Jetcore", "Jetson"];

  const deviceColumns = [
    {
      label: "Device ID",
      id: "deviceId",
      onClick: (deviceId) => {},
    },
    { label: "Device Name", id: "deviceName" },
    { label: "Status", id: "status" },
    { label: "Last updated on", id: "lastUpdated" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        margin: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ color: theme.palette.text.primary, fontSize: "28px" }}
        >
          Devices
        </Typography>
        <Button
          sx={{
            backgroundColor: "#006bce",
            color: "#fff",
            textTransform: "none",
            "&:hover": { backgroundColor: theme.palette.primary.dark },
          }}
          onClick={handleNewDeviceClick}
        >
          <AddIcon sx={{ marginRight: "4px" }} />
          Add New Device
        </Button>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" mb={2}>
            Add New Device
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Device ID"
              name="deviceId"
              value={formData.deviceId}
              onChange={handleChange}
              margin="normal"
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "white !important", // Added !important here too
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white !important", // Same here
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "white !important", // Ensures label color is also white
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "white !important", // Ensures white color on focus
                },
                input: { color: "white" }, // Ensures input text color is white
              }}
            />
            <TextField
              select
              fullWidth
              label="Select a Device"
              name="deviceName"
              value={formData.deviceName}
              onChange={handleChange}
              margin="normal"
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "white !important", // Added !important here too
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white !important", // Same here
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "white !important", // Ensures label color is also white
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "white !important", // Ensures white color on focus
                },
                input: { color: "white" }, // Ensures input text color is white
              }}
            >
              {availableDevices.map((device, index) => (
                <MenuItem key={index} value={device}>
                  {device}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              fullWidth
              label="Status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              margin="normal"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "white !important", // Added !important here too
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white !important", // Same here
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "white !important", // Ensures label color is also white
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "white !important", // Ensures white color on focus
                },
                input: { color: "white" }, // Ensures input text color is white
              }}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </TextField>
            <TextField
              fullWidth
              label="Last Updated On"
              name="lastUpdated"
              type="date"
              value={formData.lastUpdated}
              onChange={handleChange}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "white !important", // Added !important here too
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "white !important", // Same here
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "white !important", // Ensures label color is also white
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "white !important", // Ensures white color on focus
                },
                input: { color: "white" }, // Ensures input text color is white
              }}
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2, textTransform: "none", backgroundColor: "#006bce" }}
            >
              Save Device
            </Button>
          </form>
        </Box>
      </Modal>

      {/* List Component */}
      <ListComponent
        columns={deviceColumns}
        data={devices}
        handleDeviceClick={handleDeviceClick}
      />
    </Box>
  );
};

export default ProtectedDownloads;
